module.exports = __webpack_public_path__ + "img/P9-en.e2f58b07.png";